import {RDate} from '@app/core/models/rDate.model';
import {Department} from '@app/core/models/department.model';
import {User} from '@app/core/models/user.model';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {BaseModel} from '@app/core/models/base.model';
import {QMIntegration} from '@app/core/models/QMIntegration.model';

export interface IBackendLanguage {
	currency: string;
	locale: string;
	id: number;
	social_security_number_regex: string;
	account_number_regex: string;
	postal_code_regex: string;
}

export class Tenant extends BaseModel {
	public id: number;
	public getting_started: boolean;
	public finished_first_group: boolean;
	public finished_first_member: boolean;
	public finished_first_shift: boolean;
	public finished_payment_period: boolean;
	public integration_id: number;
	public integration: QMIntegration;
	public users: User[];
	public departments: Department[];
	public timezone: string;
	public language: IBackendLanguage;
	public created_at: RDate;
	public updated_at: RDate;

	public has_active_users_subscription: boolean;
	public users_subscription_expires_at: string;

	public company_name: string;
	public address: string;
	public city: string;
	public postal_code: string;
	public email: string;
	public phone_ext: string;
	public phone_number: number;
	public vat_number: number;

	public payment_period: number;
	public operational_start_time: string;

	public hub_chain_id: string;

	constructor(tenantTZ, interService: InternationalizationService) {
		super(tenantTZ, interService);
	}

	public setIntegrationType(integration_id: number = this.integration_id): void {
		this.integration_id = integration_id;
	}

	public preferredFirstCountry(): string {
		if (!this.language || !this.language.id) {
			return 'dk';
		}
		switch (this.language.id) {
			case 2:
				return 'gb';
			case 4:
				return 'no';
			default:
			case 3:
				return 'dk';
		}
	}

	public deserialize(input: any): this {
		Object.assign(this, input);
		this.setIntegrationType();
		if (input.created_at) {
			this.created_at = new RDate(this.timezone, this.interService).deserialize(input.created_at);
		}
		if (input.updated_at) {
			this.updated_at = new RDate(this.timezone, this.interService).deserialize(input.updated_at);
		}
		if (this.language && !this.language.account_number_regex) {
			this.language.account_number_regex = '^.{0,191}$';
		}
		if (this.language && !this.language.social_security_number_regex) {
			this.language.social_security_number_regex = '^.{0,191}$';
		}

		return this;
	}
}
